export enum NotificationType {  
    Success,  
    Error,  
    Info,  
    Warning  
} 